var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveReward(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#EAFFE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 32.8965H31.9059",
    stroke: "#29BE1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.6544C12 19.6222 12 19.1061 12.328 18.7854C12.6559 18.4647 13.1837 18.4647 14.2394 18.4647C15.2951 18.4647 15.8229 18.4647 16.1509 18.7854C16.4788 19.1061 16.4788 19.6222 16.4788 20.6544V27.2233C16.4788 28.2555 16.4788 28.7716 16.1509 29.0923C15.8229 29.413 15.2951 29.413 14.2394 29.413C13.1837 29.413 12.6559 29.413 12.328 29.0923C12 28.7716 12 28.2555 12 27.2233V20.6544Z",
    stroke: "#29BE1C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9624 16.6164C19.9624 15.611 19.9624 15.1083 20.2539 14.7959C20.5454 14.4836 21.0146 14.4836 21.953 14.4836C22.8914 14.4836 23.3605 14.4836 23.6521 14.7959C23.9436 15.1083 23.9436 15.611 23.9436 16.6164V27.2803C23.9436 28.2857 23.9436 28.7884 23.6521 29.1007C23.3605 29.413 22.8914 29.413 21.953 29.413C21.0146 29.413 20.5454 29.413 20.2539 29.1007C19.9624 28.7884 19.9624 28.2857 19.9624 27.2803V16.6164Z",
    stroke: "#29BE1C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4271 13.1662C27.4271 12.1451 27.4271 11.6345 27.7551 11.3172C28.0831 11 28.6109 11 29.6665 11C30.7222 11 31.25 11 31.578 11.3172C31.906 11.6345 31.906 12.1451 31.906 13.1662V27.2468C31.906 28.2679 31.906 28.7785 31.578 29.0958C31.25 29.413 30.7222 29.413 29.6665 29.413C28.6109 29.413 28.0831 29.413 27.7551 29.0958C27.4271 28.7785 27.4271 28.2679 27.4271 27.2468V13.1662Z",
    stroke: "#29BE1C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveReward);
export default __webpack_public_path__ + "static/media/live-reward.45e95373ea254cb3390d747faa76484d.svg";
export { ForwardRef as ReactComponent };